import { render, staticRenderFns } from "./keyEnterprises.vue?vue&type=template&id=b004860a&scoped=true&"
import script from "./keyEnterprises.vue?vue&type=script&lang=js&"
export * from "./keyEnterprises.vue?vue&type=script&lang=js&"
import style0 from "./keyEnterprises.vue?vue&type=style&index=0&id=b004860a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b004860a",
  null
  
)

export default component.exports